import ShipmentsNeedsFollowUpContainer from "./ShipmentsNeedsFollowUpContainer";
export default ShipmentsNeedsFollowUpContainer;
